<template>
  <div class="admin--worker-calendar">
    <v-scroll-y-transition mode="out-in">
      <div class="calendar">
        <div class="calendar-navigation">
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next" class="mr-2">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <h3
            v-if="$refs.calendarClockEntries"
            class="calendar-selector"
            style="color: var(--color1) !important;"
          >
            {{ $refs.calendarClockEntries.title }}
          </h3>
          <v-progress-circular
            v-if="loading"
            :color="$getColor('vuetifyColor1')"
            class="linear-progress"
            indeterminate
          >
          </v-progress-circular>
          <v-btn @click="isDetailView = !isDetailView" icon :dark="$getPrimaryButton('dark')" depressed
            :rounded="false" :outlined="false" :color="$getPrimaryButton('color')" class="ml-auto">
            <v-icon>{{ !isDetailView ? 'mdi-format-list-bulleted' : 'mdi-calendar' }}</v-icon>
          </v-btn>
        </div>
        <v-calendar
          v-show="!isDetailView"
          ref="calendarClockEntries"
          v-model="focus"
          :color="$getColor('vuetifyColor3')"
          :events="eventsClock"
          :event-color="getEventColor"
          :type="type"
          locale="es"
          :weekdays="weekdays"
          @change="updateRange"
          :interval-count="0"
        >
          <template v-slot:event="{ event }">
            <div class="event-chip" :class="event.blocked ? 'blocked' : ''" style="color: black !important;">
              <span style="font-weight: 600;" >{{ event.type }}</span>
              <span style="font-size: small;">{{ ":          " + trimDate(event.timeLocale) }}</span>
            </div>
          </template>
        </v-calendar>

        <div v-show="isDetailView">
          <WorkerClockEntries
            ref="workerClockEntries"
            @backToCalendar="backToCalendar()"
          />
        </div>
      </div>
    </v-scroll-y-transition>
  </div>
</template>
<script>
import clockEntryService from '@/services/clockentry.service';
import WorkerClockEntries from '@/views/_FATDA/components/WorkerClockEntries.vue';

export default {
  name: 'worker-clock-calendar',
  components: {
    WorkerClockEntries,
  },
  props: {
    workerId: {
      type: String,
      required: true,
    },
    worker: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      focus: '',
      type: 'month',
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      eventsClock: [],
      clockEntriesCurrent: [],
      loading: false,
      loaded: true,
      minDate: null,
      maxDate: null,
      isDetailView: false,
    };
  },
  methods: {
    updateData() {
      this.getUserSchedule(this.workerId);
    },
    async getUserSchedule(id) {
      if (!this.minDate || !this.maxDate) return;
      this.loading = true;
      const dateRange = clockEntryService.getDateTimeRange([this.minDate.date, this.maxDate.date], '[YYYY-MM-DD,YYYY-MM-DD]');
      clockEntryService.getClockEntriesInRange(id, dateRange.dateFrom, dateRange.dateTo).then((response) => {
        this.clockEntriesCurrent = response;
        this.updateRangeClockEntries();
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    getEventColor(event) {
      return event.color;
    },
    prev() {
      this.$refs.calendarClockEntries.prev();
    },
    next() {
      this.$refs.calendarClockEntries.next();
    },
    updateRangeClockEntries() {
      if (this.loaded) {
        const eventsCl = [];
        this.clockEntriesCurrent.forEach((item) => {
          eventsCl.push({
            id: item.id,
            blocked: false,
            start: new Date(item.clockInTime),
            end: new Date(item.clockInTime),
            date: item.clockInTime,
            unixClockInTime: item.unixClockInTime,
            sourceType: item.type,
            manualEntry: item.manualEntry,
            adminEntry: item.adminEntry,
            time: clockEntryService.unixTimeToDateTime(item.unixClockInTime),
            timeLocale: clockEntryService.unixTimeToLocaleDateTime(item.unixClockInTime),
            type: item.type ? this.$getclockEntryTypeValues(item.type).label : 'N/A',
            color: this.setClockEntryColor(item),
            timed: false,
            icon: item.type ? this.$getclockEntryTypeValues(item.type).icon : 'mdi-clock',
            workerId: item.worker.id,
            workerName: item.worker.name,
            workerLastName: item.worker.lastName1,
            workerEmail: item.worker.email,
            latitude: item.latitude,
            longitude: item.longitude,
            errorLocation: item.errorLocation,
          });
        });
        this.eventsClock = eventsCl;
        this.$refs.workerClockEntries.updateSchedule(eventsCl, this.worker);
      }
    },
    setClockEntryColor(item) {
      if (item.adminEntry) {
        return '#bd45d1';
      }
      if (item.manualEntry) {
        return 'secondary';
      }
      if (item.type === 'CLOCK_IN') {
        return 'grey';
      }
      if (item.type === 'CLOCK_OUT') {
        return 'primary';
      }
      return 'grey';
    },
    trimDate(fechaString) {
      const horaParte = fechaString.split(',')[1].trim();
      return horaParte;
    },
    updateRange(obj) {
      this.minDate = obj.start;
      this.maxDate = obj.end;
      this.getUserSchedule(this.workerId);
    },
    backToCalendar() {
      this.isDetailView = false;
    },
  },
  watch: {
    workerId() {
      this.updateData();
    },
  },
};
</script>
<style lang="scss" scoped>
.admin--worker-calendar {
  width: 100%;

  .calendar {
    width: 100%;
    overflow-x: hidden;

    .calendar-selector {
      text-transform: capitalize;
    }

    .calendar-navigation {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: calc(var(--base) * 1);
      margin-bottom: calc(var(--base) * 1);

      h3 {
        font-size: calc(var(--base) * 2.3);
        font-weight: 400;
        margin: 0;
      }
    }

    .event-chip {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      color: rgb(var(--bodyColor));
      font-weight: 500;
      &.blocked {
        &:before {
          content: "🔒";
        }
      }
    }
  }
}
</style>
